import { createFileRoute } from '@tanstack/react-router';
import { CampaignEditorPage } from '@/pages/member-portal/campaigns/CampaignEditorPage';

// Campaign editor. `$id` is either a campaign id (edit) or the literal `new`.
function MemberPortalCampaignEditorRoute() {
	return <CampaignEditorPage />;
}

export const Route = createFileRoute('/_authenticated/_app/member-portal/manage/campaigns/$id')({
	component: MemberPortalCampaignEditorRoute,
});
